<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">Lights! Camera! Monsters?</p>
<p class="subsq">Sometimes you go to the movies. And sometimes, the movies—and their monsters—come to you. At any moment, without notice, monsters once relegated to the screen become a reality. Aliens and demons, dragons and ghosts, werewolves, vampires, zombies, and seemingly ordinary people who are just plain evil.</p>
<p class="subsq">Join award-winning authors Jonathan Maberry, Fran Wilde, David Gerrold, Rick Wilber and others for 23 all-new tales of haunted theaters, video gods, formidable demons, alien pizza, and delirious actors. Each story takes you to the silver screen with monstrous results.</p>
<p class="subsq">Funny or grim, unsettling or cozy… You’ll laugh! You’ll sigh! You’ll scream!</p>
<p class="subsq">Grab popcorn—and good running shoes—and enjoy the show.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book-description.vue?3bd95a3a